import { Box, Collapse, Grid } from "@mui/material";
import { SSText } from "src/components/base/components/SSText";
import { useSSTheme } from "../../reusable/hooks/useSSTheme";
import { EventCard } from "../homepageFlow/EventCard";
import { SSButton } from "src/components/base/components/SSButton";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import React from "react";
import { TEvent } from "src/shared/types/globalStotre.types";

export function UpcomingEvents(props: {
  events: TEvent[];
  title?: string;
  showAllEvents?: boolean;
  orderEventsByDateAsc?: boolean;
}) {
  const theme = useSSTheme();
  const maxVisibleCount = props?.showAllEvents ? Infinity : 4;
  let visibleEvents = props.events.slice(0, maxVisibleCount);
  const collapsedEvents = props.events.slice(maxVisibleCount);
  const [isCollapseOpen, setIsCollapseOpen] = React.useState(false);

  if (props.orderEventsByDateAsc) {
    visibleEvents = visibleEvents.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
    );
  }

  return (
    <Box width={"100%"}>
      <Box>
        <SSText variant="h6" fontWeight={700} color={theme.colors.gray[200]}>
          {props.title || "Upcoming Games"}
        </SSText>
      </Box>
      <Box mt={2}>
        <Grid container spacing={4}>
          {visibleEvents.map((event, idx) => {
            return (
              <Grid item key={idx * Math.random()} xs={12}>
                <EventCard event={event} />
              </Grid>
            );
          })}
        </Grid>
      </Box>

      <Box mt={2}>
        <Collapse in={isCollapseOpen}>
          <Grid container spacing={4}>
            {collapsedEvents.map((event, idx) => {
              return (
                <Grid item key={idx * Math.random()} xs={12}>
                  <EventCard event={event} />
                </Grid>
              );
            })}
          </Grid>
        </Collapse>
      </Box>

      {collapsedEvents.length > 0 ? (
        <Box mt={2}>
          <SSButton
            fullWidth
            size="large"
            variant="contained"
            colorScheme={theme.colors.teamPrimary}
            disableElevation
            endIcon={
              isCollapseOpen ? (
                <KeyboardArrowUpRoundedIcon />
              ) : (
                <KeyboardArrowDownRoundedIcon />
              )
            }
            onClick={() => setIsCollapseOpen(!isCollapseOpen)}
          >
            {isCollapseOpen ? "View Less" : "View Full Schedule"}
          </SSButton>
        </Box>
      ) : null}
    </Box>
  );
}
